<style scoped>
.delimiter {
  text-align: center;
}

.delimiter h6 {
  font-size: 1.1rem;
  margin-bottom: 0 !important;
}

.delimiter hr {
  margin-top: 0 !important;
  margin-bottom: .5rem !important;
}
</style>

<template>
  <div>
    <div class="col-md-12 delimiter" v-if="schema.title">
      <h6>{{ schema.title }}</h6>
      <hr/>
    </div>
    <address-form-fields
      ref="form"
      :placeholder="schema.placeholder"
      :form="value"
      :disabled="disabled"
      :removed-fields="schema.removedFields"
      @address-updated="value = $event"
    />
    <div class="col-md-12 delimiter">
      <hr/>
    </div>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import AddressFormFields from '@/components/utils/address/AddressFormFields';

export default {
  components: {
    AddressFormFields,
  },
  mixins: [abstractField],
  methods: {
    validate() {
      this.clearValidationErrors();
      const isValid = this.$refs.form.validate();
      const validateAsync = this.formOptions.validateAsync;
      const results = isValid ? [] : [''];
      if (!validateAsync) {
        return results;
      }
      return Promise.all(results);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/custom_fields/general/fieldSplitAddress.vue